var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59 12.077a.565.565 0 0 0 .816 0l3.938-4.125a.562.562 0 0 0-.813-.776l-2.97 3.108V2.312a.56.56 0 0 0-.563-.562.56.56 0 0 0-.562.563v7.97l-2.967-3.11a.562.562 0 0 0-.814.776l3.938 4.125z"
  })));
};
export default SvgArrowDown;